<template>
    <div class="component-pdf-viewer-container">
        <Loader v-if="loading"/>

        <div v-else class="component-pdf-viewer">
            <pdf-page :src="pdfData" v-for="i in numPages" :key="i" :id="i" :page="i" scale="page-width"></pdf-page>
        </div>

    </div>
</template>

<script>
    import Loader from './Loader.vue';
    import pdfvuer from 'pdfvuer';

    export default {
        props: ['url'],
        data: () => ({
            loading: true,
            numPages: 0,
            pdfData: undefined
        }),
        components: {
            Loader,
            'pdf-page': pdfvuer
        },
        computed: {},
        watch: {
            url: {
                handler: function () {
                    this.load();
                }
            }
        },
        methods: {
            load() {
                if (this.url === '' || this.url === null) {
                    console.debug('Trying to load empty PDF URL');
                    return;
                }

                this.loading = true;
                this.pdfData = pdfvuer.createLoadingTask(this.url);
                this.pdfData
                    .then(pdf => {
                        this.numPages = pdf.numPages
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            }
        },
        mounted() {
            this.load();
        }
    }
</script>

<style lang="scss">
    .component-pdf-viewer {
        background: #666;
        overflow-y: scroll;
        overflow-x: hidden;
        height: 100%;
    }

    /*
      ##Device = Tablets, Ipads (landscape), Desktops, Laptops
      ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) {
        .component-pdf-viewer {
            padding: 15px 30px;
        }

        .page {
            margin: 15px auto;
        }
    }

    /*
      ##Device = Most of the Smartphones Mobiles (Portrait)
      ##Screen = B/w 320px to 479px
    */
    @media (min-width: 320px) and (max-width: 767px) {
        .component-pdf-viewer {
            padding: 0;
        }

        .page {
            margin: 10px auto;
        }
    }

    .page {
        canvas {
            border: 1px solid #ccc;
        }
    }

    .component-pdf-viewer-container {
        height: 100%;
    }


</style>
